import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionIdRaw = searchParams.get('session_id');
  const sessionId = (sessionIdRaw || '').trim() || null;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(sessionId));
  const [error, setError] = useState(null);

  // ✅ Επίσημο CaseMaster URL (web.app)
  const appUrl = useMemo(() => {
    if (!sessionId) return 'https://casemaster-28689.web.app/';
    return `https://casemaster-28689.web.app/?session_id=${encodeURIComponent(sessionId)}`;
  }, [sessionId]);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      setData(null);
      setError(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        setError(null);

        const url = `/api/stripe-session?session_id=${encodeURIComponent(sessionId)}`;

        const r = await fetch(url, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });

        const ct = r.headers.get('content-type') || '';
        if (!ct.includes('application/json')) {
          const text = await r.text();
          throw new Error('Μη έγκυρη απάντηση server: ' + text.slice(0, 120));
        }

        const j = await r.json();
        if (!r.ok || j?.ok === false || j?.error) {
          throw new Error(j?.message || j?.error || 'Request failed');
        }

        if (cancelled) return;
        setData(j);
      } catch (e) {
        if (cancelled) return;
        setError(e?.message || String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  const session = data?.session;
  const email =
    session?.customer_details?.email ??
    session?.customer_email ??
    session?.metadata?.email ??
    '—';

  const plan = session?.metadata?.plan ?? '—';
  const cycle = session?.metadata?.billingPeriod ?? session?.metadata?.cycle ?? '—';
  const status = session?.payment_status ?? '—';

  return (
    <main style={{ maxWidth: 720, margin: '40px auto', padding: 24, color: 'white' }}>
      <h1>✅ Επιτυχία (Test)</h1>

      {!sessionId && (
        <div style={card}>
          <p style={{ marginTop: 0 }}>Δεν βρέθηκε session_id στο URL.</p>
          <p style={{ opacity: 0.9 }}>
            Πάτα το κουμπί για να ανοίξεις το CaseMaster και να συνδεθείς με το email της αγοράς.
          </p>

          <a href={appUrl} target="_blank" rel="noreferrer" style={primaryBtn}>
            🚀 Άνοιγμα CaseMaster
          </a>
        </div>
      )}

      {loading && <p>Φόρτωση…</p>}

      {error && (
        <div style={{ ...card, borderColor: 'rgba(255,80,80,0.45)' }}>
          <p style={{ color: '#ff9b9b', marginTop: 0 }}>Σφάλμα: {error}</p>
          <p style={{ opacity: 0.9 }}>
            Δεν πειράζει — πάτα το κουμπί για να ανοίξεις το CaseMaster.
          </p>

          <a href={appUrl} target="_blank" rel="noreferrer" style={primaryBtn}>
            🚀 Άνοιγμα CaseMaster
          </a>
        </div>
      )}

      {!loading && !error && data && sessionId && (
        <div style={card}>
          <p style={{ marginTop: 0, fontWeight: 800 }}>
            Η πληρωμή ολοκληρώθηκε ✅
          </p>

          <p style={{ opacity: 0.9 }}>
            Επόμενο βήμα: άνοιξε το CaseMaster και κάνε σύνδεση/εγγραφή με το ίδιο email της αγοράς.
            Η ενεργοποίηση θα γίνει αυτόματα.
          </p>

          <div style={{ marginTop: 12, lineHeight: 1.6, opacity: 0.95 }}>
            <div>📧 <b>{email}</b></div>
            <div>💼 Πλάνο: <b>{plan}</b> • Κύκλος: <b>{cycle}</b></div>
            <div>✅ Status: <b>{status}</b></div>
          </div>

          <div style={{ marginTop: 16 }}>
            <a href={appUrl} target="_blank" rel="noreferrer" style={primaryBtn}>
              🚀 Άνοιγμα CaseMaster
            </a>
          </div>

          <div style={{ marginTop: 12, fontSize: 12, opacity: 0.7 }}>
            Tip: Αν πλήρωσες με άλλο email, πρέπει να συνδεθείς με εκείνο.
          </div>
        </div>
      )}
    </main>
  );
}

const card = {
  border: '1px solid rgba(255,255,255,0.12)',
  padding: 16,
  borderRadius: 12,
  background: 'rgba(0,0,0,0.18)',
};

const primaryBtn = {
  display: 'inline-block',
  padding: '12px 16px',
  borderRadius: 10,
  textDecoration: 'none',
  background: '#19E6FF',
  color: '#001018',
  fontWeight: 900,
};
